import styled from 'styled-components';

export const DivTitleModal = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: 13px;
  box-sizing: border-box;

  div {
    display: flex;
    align-items: center;
    gap: 10px;
    font: normal normal 600 24px/34px Source Sans Pro;
    letter-spacing: 0px;
    color: #424242;
    opacity: 1;
  }
`;
